const identityServerUrl =
    process.env.VUE_APP_IDENTITY_SERVER_URL ||
    'https://identity.gethighered.global/';

export default {
    baseURL: identityServerUrl,
    template: [
        'USER_TEMPLATE',
        data => ({
            id: data.id,
            email: data.email,
            firstName: data.firstName,
            lastName: data.lastName,
            nationality: data.nationality,
            phoneNumber: data.phoneNumber,
            image: data.avatar,
            newsLetterConsent: data.newsLetterConsent,

            firstLetterInName:
                data.firstName && data.firstName.length > 0
                    ? data.firstName[0].toUpperCase()
                    : data.email && data.email.length > 0
                    ? data.email[0].toUpperCase()
                    : 'A',
        }),
    ],

    // Creating user
    POST: {},

    '/me': {
        authorize: true,
        GET: {},
        PUT: {},
    },

    '/email': {
        template: [
            'USER_EMAIL_TEMPLATE',
            data => ({
                id: 1,
                code: data.code,
                message: data.message,
            }),
        ],
        '/confirm': {
            // Send/Resend confirmation email (used for creating a user)
            POST: {},
        },
        '/verify': {
            // Endpoint used by page user clicks on in confirmation email
            GET: {},
        },
    },
    '/avatar': {
        baseURL: identityServerUrl,
        authorize: true,
        template: [
            'AVATAR_TEMPLATE',
            data => ({
                image: data.avatar,
            }),
        ],
        POST: {},
    },

    '/forgot-password': {
        POST: {},
        template: ['FORGOT_PASSWORD', () => ({})],
    },

    '/reset-password': {
        POST: {},
        template: ['RESET_PASSWORD', () => ({})],
    },

    '/activate': {
        POST: {},
    },
};
